export default __webpack_public_path__ + "static/right-phone-b682037d7ae30217bf0a616fd098e91e.webp";